/**
 * Deterministic per-instructor accent for multi-instructor calendars.
 * Maps an instructor id to one of a small set of saturated project-palette
 * classes (mid-tone shades that read on both light and dark surfaces, the
 * same convention as the fixed avatar colors).
 */
const ACCENT_CLASSES = [
  "bg-primary-50",
  "bg-secondary-50",
  "bg-tertiary-40",
  "bg-primary-70",
  "bg-secondary-70",
  "bg-tertiary-60",
];

const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const instructorAccentClass = (instructorId: string): string =>
  ACCENT_CLASSES[hashString(instructorId) % ACCENT_CLASSES.length];
